module.exports = __webpack_public_path__ + "img/Step05b5.da881d71.webp";